// 9fbef606107a605d69c0edbcd8029e5d
import { call, put, take, takeLatest } from 'redux-saga/effects';
import constants from '../MailingAddress.constants';
import { addMailingAddressSuccess, addMailingAddressFail } from './MailingAddress.actions';
import {
  setAddressBookNotification,
  clearGetAddressListTTL,
} from '../../../../AddressBook/container/AddressBook.actions';
import CONSTANTS from '../../../../User/User.constants';
import { getUserInfo } from '../../../../User/container/User.actions';
import { updateProfileSuccess } from '../../../container/MyProfile.actions';

import { addUpdateMailingAddress } from '../../../../../../../services/abstractors/account/AddEditAddress';

export function* updateMailingAddressPut({ payload }) {
  try {
    const { address1 } = payload;

    if (!address1) {
      throw new Error('Address1 is required.');
    }

    const res = yield call(addUpdateMailingAddress, payload);
    if (res) {
      yield put(
        setAddressBookNotification({
          status: 'success',
        })
      );
      yield put(clearGetAddressListTTL());
      yield put(
        getUserInfo({
          ignoreCache: true,
        })
      );
      yield take(CONSTANTS.SET_USER_INFO);
      yield put(updateProfileSuccess('successMessage'));
      return yield put(addMailingAddressSuccess(res.data.addUpdateMailingAddress));
    }
    return yield put(addMailingAddressFail(res.data?.errors[0].message));
  } catch (err) {
    return yield put(addMailingAddressFail(err[0].errorMessage));
  }
}

export default function* MailingAddressSaga() {
  yield takeLatest(constants.ADD_MAILING_ADDRESS, updateMailingAddressPut);
}
